import React from 'react'
import {
  IssueContainer,
  InnerIssueContainer,
  MainContent,
  IssueTitle,
  SidebarP,
  Sidebar,
  SidebarHeader,
  SidebarSubheader,
  CloseButton
} from '.'

interface Props {
  handleClose: () => void
}

export default function WorkersCard({ handleClose }: Props) {
  return (
    <IssueContainer>
      <InnerIssueContainer>
        <MainContent>
          <IssueTitle>An Economy for People</IssueTitle>
          <SidebarP>
            Middle Tennessee is home to thriving industries including construction, healthcare, agriculture, tourism and many others.
            However, thriving business does not equate to thriving wages or safe work conditions. Justin will advocate for Tennessee workers
            to ensure that all are treated fairly, paid living wages, and have equal protection under the law. Justin stands with working
            families to fight for an economy that values people above profits. Justin’s campaign is funded by small dollars and people, not
            corporations.
          </SidebarP>
          <SidebarP>
            Justin will fight for a better working economy. This will require comprehensive efforts to address: workers compensation,
            workforce development, safety and training, protections for working people, a federal jobs guarantee, a living wage, and the
            power of organized labor. Justin supports a regulation of massive industry including protections against wage-theft, sexual
            harrasment, and discrimination. While Middle Tennessee attracts attention for its building boom, construction workers face
            on-site injuries and deaths. This issue disproportionately affects immigrant communities and it is time to ensure a dignified
            workplace for those who are building up Middle Tennessee.
          </SidebarP>
          <SidebarP>
            Justin supports a modernized tax code to ensure that corporations and the ultra-wealthy pay back into our democracy. People will
            never come first as long as corporations dictate the rules of our democracy.
          </SidebarP>
        </MainContent>
        <Sidebar>
          {/* <SidebarHeader>JUSTIN SUPPORTS</SidebarHeader>
          <SidebarSubheader href="https://www.congress.gov/bill/116th-congress/house-bill/4857?q=%7B%22search%22%3A%5B%22A%22%5D%7D&s=1&r=7">
            HR 4857- For The 99.8% Act
          </SidebarSubheader>
          <SidebarP>Joining 37 co-sponsors, including TN representative Steven Cohen (TN-09).</SidebarP> */}
          <SidebarHeader>RESOURCES</SidebarHeader>
          <SidebarSubheader href="https://www.epi.org/productivity-pay-gap/">The Productivity-Pay Gap</SidebarSubheader>
          <SidebarSubheader href="https://calaborfed.org/weakening-of-unions-is-directly-related-to-exploding-inequality/">
            Weakening of Unions is Directly Related to Exploding Inequality
          </SidebarSubheader>
        </Sidebar>
      </InnerIssueContainer>
      <CloseButton onClick={handleClose}>CLOSE</CloseButton>
    </IssueContainer>
  )
}
